export function getCanonicalProfilePath(profile) {
  const identifier = typeof profile === 'object' && profile !== null
    ? profile.userHandle || profile.username || profile.tag || profile.id || profile.userId || profile.uid
    : profile;
  return identifier == null ? '/' : `/profile/${encodeURIComponent(String(identifier).replace(/^@/, ''))}`;
}
